/**
 * How a reader can reach the clinic, as one vocabulary.
 *
 * A fixed list rather than free text because these end up in generated copy as
 * instructions to the reader, and 「LINE」 and 「ライン」 and 「LINE予約」 are the same
 * channel written three ways.
 *
 * IN `shared/` because three readers need it and they were not agreeing. The
 * catalogue screen held the list, the prompt held its own copy of the labels,
 * and the CTA block inserted into an article held neither - so a clinic that
 * chose Web予約 and LINE published 「ご予約・ご相談：web／line」 to its patients, in
 * English, in lower case. One list, one set of labels, no third copy to drift.
 */
export const CTA_CHANNELS = [
  { value: 'web', label: 'Web予約' },
  { value: 'line', label: 'LINE' },
  { value: 'phone', label: '電話' },
  { value: 'mail', label: 'メール' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'walkin', label: '来院・当日受付' },
] as const;

export const CHANNEL_LABEL: Record<string, string> = Object.fromEntries(
  CTA_CHANNELS.map((channel) => [channel.value, channel.label]),
);

/** The stored values as a reader would recognise them; unknown values stay as they are. */
export const channelLabels = (channels: readonly unknown[]): string[] =>
  channels
    .filter((entry): entry is string => typeof entry === 'string' && entry !== '')
    .map((entry) => CHANNEL_LABEL[entry] ?? entry);
